import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { CheckCircle, Loader2, Star } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SponsorExitosoPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const session_id = searchParams.get("session_id");
  const [loading, setLoading] = useState(true);
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    if (session_id) {
      verificarSponsor();
    } else {
      navigate("/");
    }
  }, [session_id]);

  const verificarSponsor = async () => {
    let attempts = 0;
    const maxAttempts = 10;

    const checkStatus = async () => {
      try {
        const response = await axios.get(`${API}/sponsors/verificar/${session_id}`);
        
        if (response.data.payment_status === "paid") {
          setVerified(true);
          setLoading(false);
          toast.success("¡Gracias por ser patrocinador!");
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkStatus, 2000);
        } else {
          setLoading(false);
          toast.error("No se pudo verificar el pago");
        }
      } catch (error) {
        console.error("Error verificando sponsor:", error);
        if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkStatus, 2000);
        } else {
          setLoading(false);
          toast.error("Error verificando el pago");
        }
      }
    };

    checkStatus();
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-warm-bone flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="animate-spin h-16 w-16 text-zuno-wine mx-auto mb-4" />
          <p className="text-xl text-slate-600">Verificando tu pago...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-warm-bone py-12">
      <div className="container mx-auto px-6 md:px-12 lg:px-24 max-w-4xl">
        <div className="glass-card rounded-3xl p-8 md:p-12 text-center">
          {verified ? (
            <>
              <CheckCircle className="h-24 w-24 text-green-500 mx-auto mb-6" />
              <h1 className="text-4xl md:text-5xl font-bold text-zuno-wine mb-4">
                ¡Gracias por Ser Patrocinador!
              </h1>
              <p className="text-xl text-slate-600 mb-8">
                Tu apoyo es fundamental para el éxito de nuestro evento
              </p>
              <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-2xl p-8 mb-8">
                <Star className="h-16 w-16 text-zuno-wine mx-auto mb-4" fill="#722F37" />
                <h2 className="text-2xl font-semibold text-slate-800 mb-4">
                  Próximos Pasos
                </h2>
                <div className="text-left max-w-2xl mx-auto space-y-3">
                  <p className="text-slate-700">
                    ✓ Recibirás un correo de confirmación con los detalles de tu patrocinio
                  </p>
                  <p className="text-slate-700">
                    ✓ Nos contactaremos contigo para recibir tu logo y cualquier material adicional
                  </p>
                  <p className="text-slate-700">
                    ✓ Tu logo será incluido en todo el material promocional según tu paquete
                  </p>
                  <p className="text-slate-700">
                    ✓ Te mantendremos informado sobre el progreso del evento
                  </p>
                </div>
              </div>
            </>
          ) : (
            <>
              <h1 className="text-4xl font-bold text-slate-700 mb-4">
                No se pudo verificar el pago
              </h1>
              <p className="text-lg text-slate-600 mb-8">
                Por favor contacta al soporte si completaste el pago
              </p>
            </>
          )}
          
          <Button
            onClick={() => navigate("/")}
            className="btn-primary"
            size="lg"
            data-testid="back-home-btn"
          >
            Volver al Inicio
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SponsorExitosoPage;
